import { SearchField } from '@automata/ui';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useURLSearchParams } from 'hooks/useURLSearchParams';

const Spacer = styled('div')`
  height: 20px;
`;

export const WorkcellsListToolbar = (): JSX.Element => {
  const [searchParams, setSearchParams] = useURLSearchParams();

  const { name } = searchParams as {
    name: string;
  };

  const [nameSearch, setNameSearch] = useState(name ?? '');

  const filterRef = useRef<HTMLInputElement>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetParams = useCallback(
    debounce((value: string) => {
      setSearchParams({ name: value });
    }, 500),
    []
  );

  useEffect(() => {
    debouncedSetParams(nameSearch);
  }, [nameSearch, debouncedSetParams]);

  useEffect(() => {
    filterRef.current?.focus();
  }, []);

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      width="100%"
    >
      <Stack>
        <Spacer />
        <SearchField
          autoFocus
          ref={filterRef}
          value={nameSearch}
          variant="outlined"
          placeholder="Search Workcells"
          onChange={setNameSearch}
        />
      </Stack>
    </Stack>
  );
};

export default WorkcellsListToolbar;
